<template>
  <button :class="{ next }">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="black">
      <path d="M8.51938 14.5609C8.16294 14.9181 8.16325 15.4966 8.52008 15.8534C8.87719 16.2105 9.45618 16.2105 9.81329 15.8534L13.9596 11.7071C14.3501 11.3166 14.3501 10.6834 13.9596 10.2929L9.81329 6.1466C9.45618 5.7895 8.87719 5.78949 8.52009 6.1466C8.16325 6.50344 8.16294 7.08188 8.51938 7.4391L12.0725 11L8.51938 14.5609Z"/>
    </svg>
  </button>
</template>

<script>
  export default {
    name: "ArrowButton",
    props: {
      next: Boolean,
    },
  };
</script>

<style lang="scss" scoped>
  button {
    border-radius: 54px;
    border: 1px solid var(--black);
    user-select: none;
    user-select: none;
    display: grid;
    place-items: center;
    width: 40px;
    height: 40px;
    cursor: pointer;

    &.next svg {
      transform: scaleX(1);
    }

    @media (hover: hover) {
      transition: 0.2s all ease-in-out;

      &:hover {
        background: var(--light-green);        
        svg {
          fill:var(--white);
        }
      }
    }
  }

  svg {
    transform: scaleX(-1);
    width: 100%;
  }
</style>